/**
 * Output, as its own top-level page.
 *
 * This used to be a place inside Home, reached by first landing on the
 * dashboard and then picking "Output" from a rail of six other destinations —
 * findable once and then easy to lose again. It is the part of the app a
 * deployed user actually needs most (every run ends here), so it gets its own
 * name in the top bar instead of living a click below Home.
 *
 * All the real work — the project/folder tree, the file viewer — is
 * `OutputPane`, unchanged; this is just that page's entry in the tab registry,
 * owning the one piece of state (the recent-cases list) `OutputPane` needs
 * that used to live in `HomePage`.
 */

import { useEffect, useState } from "react";

import { listRecentCases } from "@/ipc/api";
import type { RecentCase } from "@/ipc/contract";
import { OutputPane } from "./OutputPane";

export function OutputTab() {
  const [recent, setRecent] = useState<RecentCase[]>([]);

  const reload = () => {
    void listRecentCases()
      .then(setRecent)
      .catch(() => setRecent([]));
  };
  useEffect(reload, []);

  return <OutputPane recent={recent} onRefresh={reload} />;
}

export default OutputTab;
